import React from "react";
import {
  Grid,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps
} from "@mui/material";
import LocalHospitalOutlinedIcon from "@mui/icons-material/HealthAndSafety"; //import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import {
  StyledFont,
  StyledLeftMemberToolTipGrid,
  StyledRightMemberToolTipGrid,
  StyledMemberToolTipContainer,
  StyledMemberToolTipText,
  StyledMeasurementToolTip,
  StyledDot,
  StyledRowReadingTileContainer,
  MemberColumnContainer,
  MemberColumnBottomContainer,
  MemberColumnUpperContainer,
  InnerRow,
  WrapperContainer
} from "./Main.styles";
import {
  toLocalTime,
  toLastFirstName,
  formatSpirometry,
  formatReading,
  formatTableDisplayValue
} from "helpers/variables";
import {
  DASH,
  ELLIPSIS,
  UNITS,
  MILIGRAM,
  PAGE_REDIRECTION_TYPES
} from "helpers/appConstants";
import {
  StyledReadingText,
  StyledReadingInfoText,
  StyledLastReadingSquare
} from "views/PatientBoard/microViews/Vitals/Vitals.styles";
import { memberObject } from "context/initialState/Member";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 320,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9"
  }
}));
const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 600,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9"
  }
}));

export const memberColumn = (
  memberInfo: any,
  goToMemberPage: Function,
  item: any
) => {
  const {
    firstName,
    lastName,
    email,
    site,
    birthDate,
    program,
    groups,
    externId,
    hubIds
  } = memberInfo;
  return (
    <MemberColumnContainer>
      <MemberColumnUpperContainer>
        <StyledFont>
          {
            <HtmlTooltip
              title={
                <React.Fragment>
                  <StyledMemberToolTipContainer>
                    <div>
                      <Grid container>
                        <StyledLeftMemberToolTipGrid item xs={4}>
                          <StyledMemberToolTipText>
                            Email:
                          </StyledMemberToolTipText>
                          <StyledMemberToolTipText>
                            Program:
                          </StyledMemberToolTipText>
                          <StyledMemberToolTipText>
                            Group:
                          </StyledMemberToolTipText>
                          <StyledMemberToolTipText>
                            Site:
                          </StyledMemberToolTipText>
                          <StyledMemberToolTipText>
                            IMEI:
                          </StyledMemberToolTipText>
                        </StyledLeftMemberToolTipGrid>
                        <StyledRightMemberToolTipGrid item xs={6.7}>
                          <StyledMemberToolTipText>
                            {formatTableDisplayValue(email, ELLIPSIS)}
                          </StyledMemberToolTipText>
                          <StyledMemberToolTipText>
                            {formatTableDisplayValue(program, ELLIPSIS)}
                          </StyledMemberToolTipText>
                          <StyledMemberToolTipText>
                            {formatTableDisplayValue(groups[0], ELLIPSIS)}
                          </StyledMemberToolTipText>
                          <StyledMemberToolTipText>
                            {formatTableDisplayValue(site, ELLIPSIS)}
                          </StyledMemberToolTipText>
                          <StyledMemberToolTipText>
                            {hubIds && hubIds.length > 0
                              ? hubIds
                                  .toString()
                                  .replace(",", " & ")
                                  .toUpperCase()
                              : "..."}
                          </StyledMemberToolTipText>
                        </StyledRightMemberToolTipGrid>
                      </Grid>
                    </div>
                  </StyledMemberToolTipContainer>
                </React.Fragment>
              }
              placement="right-start"
            >
              <div onClick={() => goToMemberPage(item)}>
                {toLastFirstName(`${firstName} ${lastName}`)}
              </div>
            </HtmlTooltip>
          }
        </StyledFont>
      </MemberColumnUpperContainer>
      <MemberColumnBottomContainer>
        <InnerRow>
          <div>DOB:</div>
          <div>{formatTableDisplayValue(birthDate, DASH)}</div>
        </InnerRow>
        <InnerRow>
          <div>MRN:</div>
          <div>{formatTableDisplayValue(externId, DASH)}</div>
        </InnerRow>
      </MemberColumnBottomContainer>
    </MemberColumnContainer>
  );
};

export const admittedColumn = (member: any) => {
  const { status } = member;
  return (
    <div>
      {status === "admitted" ? (
        <HtmlTooltip title="The member is currently under hospital care">
          <LocalHospitalOutlinedIcon />
        </HtmlTooltip>
      ) : (
        ""
      )}
    </div>
  );
};

export const lastMeasurmentColumn = (lastmeasurement: any) => {
  const { readingsArray } = lastmeasurement;
  return (
    <StyledFont>
      <StyledTooltip
        title={
          <React.Fragment>
            <StyledMeasurementToolTip>
              {readingsArray.map((toolReading: any) => {
                const { id, type, date, value } = formatReading(toolReading);
                return (
                  <StyledLastReadingSquare key={id}>
                    <StyledReadingText>
                      {type !== ""
                        ? type.toLocaleLowerCase()
                        : "Member created"}
                    </StyledReadingText>
                    <StyledReadingInfoText>{value}</StyledReadingInfoText>
                    <p>{date}</p>
                  </StyledLastReadingSquare>
                );
              })}
            </StyledMeasurementToolTip>
          </React.Fragment>
        }
        placement="right-start"
      >
        <div>
          {readingsArray[0]
            ? `${readingsArray[0].type}, ${toLocalTime(
                readingsArray[0].measuredAt
              )}`
            : "..."}
        </div>
      </StyledTooltip>
    </StyledFont>
  );
};

export const breachColumn = (latestReading: any) => {
  let breached = false;
  if (latestReading) {
    breached = latestReading.breached;
  }
  return (
    <div>
      {breached ? (
        <HtmlTooltip
          title="The most recent reading for this member has breached it's threshold"
          arrow
        >
          <StyledDot />
        </HtmlTooltip>
      ) : (
        ""
      )}
    </div>
  );
};
// @ts-ignore
export const GoToReadingsWrapper = (props) => {
  const { children, type, member, goToReadings } = props;
  const { id, name } = member;
  return (
    <WrapperContainer onClick={() => goToReadings(type, id, name)}>
      {children}
    </WrapperContainer>
  );
};

const NoReadingsFallback = () => {
  return (
    <StyledRowReadingTileContainer>
      <div
        style={{
          background: "#f4f4f4",
          width: "98%",
          height: "98%",
          display: "grid",
          placeItems: "center"
        }}
      >
        <RemoveCircleOutlineIcon fontSize="large" color="action" />
      </div>
    </StyledRowReadingTileContainer>
  );
};

export const bloodPressureColumn = (
  recentBP: any,
  member: memberObject,
  goToReadings: Function
) => {
  const { measuredAt, metrics } = recentBP;
  return (
    <GoToReadingsWrapper
      type={PAGE_REDIRECTION_TYPES.bp}
      member={member}
      goToReadings={goToReadings}
    >
      {metrics?.systolic && metrics?.diastolic ? (
        <StyledRowReadingTileContainer>
          <b>SBP/DBP mmHg</b>
          {`${metrics?.systolic} / ${metrics?.diastolic}`}
          <div>{toLocalTime(measuredAt)}</div>
        </StyledRowReadingTileContainer>
      ) : (
        <NoReadingsFallback />
      )}
    </GoToReadingsWrapper>
  );
};

export const bloodGlucoseColumn = (
  recentBgl: any,
  member: memberObject,
  goToReadings: Function
) => {
  const { measuredAt, metrics } = recentBgl;
  return (
    <GoToReadingsWrapper
      type={PAGE_REDIRECTION_TYPES.bgl}
      member={member}
      goToReadings={goToReadings}
    >
      {metrics?.glucose ? (
        <StyledRowReadingTileContainer>
          <b>
            {metrics?.units === MILIGRAM ? UNITS.glucose.mg : UNITS.glucose.mm}
          </b>
          {metrics?.glucose}
          <div>{toLocalTime(measuredAt)}</div>
        </StyledRowReadingTileContainer>
      ) : (
        <NoReadingsFallback />
      )}
    </GoToReadingsWrapper>
  );
};

export const pulseOxygenColumn = (
  recentSPO2: any,
  member: memberObject,
  goToReadings: Function
) => {
  const { measuredAt, metrics } = recentSPO2;
  return (
    <GoToReadingsWrapper
      type={PAGE_REDIRECTION_TYPES.spo2}
      member={member}
      goToReadings={goToReadings}
    >
      {metrics?.spo2 ? (
        <StyledRowReadingTileContainer>
          <b>SP02%</b>
          <div>{metrics?.spo2}%</div>
          <div>{toLocalTime(measuredAt)}</div>
        </StyledRowReadingTileContainer>
      ) : (
        <NoReadingsFallback />
      )}
    </GoToReadingsWrapper>
  );
};

export const spirometryColumn = (
  recentSpirometryReading: any,
  member: memberObject,
  goToReadings: Function
) => {
  const { measuredAt } = recentSpirometryReading;
  const { FVC, FEV1 } = formatSpirometry(recentSpirometryReading);
  const numFVC = Number(FVC);
  const numFEV1 = Number(FEV1);
  const result =
    numFVC > 0 && numFEV1 > 0
      ? `${((numFEV1 / numFVC) * 100).toFixed(1)} %`
      : "-";
  return (
    <GoToReadingsWrapper
      type={PAGE_REDIRECTION_TYPES.spir}
      member={member}
      goToReadings={goToReadings}
    >
      {FVC || FEV1 ? (
        <StyledRowReadingTileContainer>
          <b>{`FEV1/FVC`}</b>
          <div>{result}</div>

          <div>{toLocalTime(measuredAt)}</div>
        </StyledRowReadingTileContainer>
      ) : (
        <NoReadingsFallback />
      )}
    </GoToReadingsWrapper>
  );
};

export const temperatureColumn = (
  recentTemp: any,
  member: memberObject,
  goToReadings: Function
) => {
  const { measuredAt, metrics } = recentTemp;
  return (
    <GoToReadingsWrapper
      type={PAGE_REDIRECTION_TYPES.temp}
      member={member}
      goToReadings={goToReadings}
    >
      {metrics?.temp ? (
        <StyledRowReadingTileContainer>
          <b>{`${metrics?.units.toUpperCase()}`}</b>
          <div>&deg;{`${metrics?.temp}`}</div>
          <div>{toLocalTime(measuredAt)}</div>
        </StyledRowReadingTileContainer>
      ) : (
        <NoReadingsFallback />
      )}
    </GoToReadingsWrapper>
  );
};

export const weightColumn = (
  recentWt: any,
  member: memberObject,
  goToReadings: Function
) => {
  const { measuredAt, metrics } = recentWt;
  return (
    <GoToReadingsWrapper
      type={PAGE_REDIRECTION_TYPES.wt}
      member={member}
      goToReadings={goToReadings}
    >
      {metrics?.weight ? (
        <StyledRowReadingTileContainer>
          <b>lbs</b>
          <div>{metrics?.weight}</div>
          <div>{toLocalTime(measuredAt)}</div>
        </StyledRowReadingTileContainer>
      ) : (
        <NoReadingsFallback />
      )}
    </GoToReadingsWrapper>
  );
};

//column for activity
export const activityColumn = (
  recentActivity: any,
  member: memberObject,
  goToReadings: Function
) => {
  const { measuredAt, metrics } = recentActivity;
  return (
    <GoToReadingsWrapper
      type={PAGE_REDIRECTION_TYPES.activity}
      member={member}
      goToReadings={goToReadings}
    >
      {metrics?.steps ? (
        <StyledRowReadingTileContainer>
          <b>steps</b>
          <div>{metrics?.steps}</div>
          <div>{toLocalTime(measuredAt)}</div>
        </StyledRowReadingTileContainer>
      ) : (
        <NoReadingsFallback />
      )}
    </GoToReadingsWrapper>
  );
};

export const heartRateColumn = (
  recents: any,
  member: memberObject,
  goToReadings: Function
) => {
  const { bp, spo2, hr } = recents;
  let timeStamp = spo2.measuredAt;
  const displayedReading = () => {
    if (spo2) {
      return <div>{`${spo2.metrics ? spo2.metrics.pulse : ""}, bpm`}</div>;
    } else if (bp) {
      timeStamp = bp.measuredAt;
      return <div>{`${bp.metrics ? bp.metrics.pulse : ""}, bpm`}</div>;
    } else if (hr) {
      timeStamp = hr.measuredAt;
      return <div>{`${hr ? hr.metrics.pulse : ""}, bpm`}</div>;
    }
  };
  return (
    <GoToReadingsWrapper
      type={PAGE_REDIRECTION_TYPES.hr}
      member={member}
      goToReadings={goToReadings}
    >
      {hr || bp || spo2 ? (
        <StyledRowReadingTileContainer>
          <b>Pulse</b>
          {displayedReading()}
          <div>{toLocalTime(timeStamp)}</div>
        </StyledRowReadingTileContainer>
      ) : (
        <NoReadingsFallback />
      )}
    </GoToReadingsWrapper>
  );
};
